module.exports = __webpack_public_path__ + "media/new_images/iphone-frame-9e7f143e.svg";